import React from "react";
export const Phone = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.17921 2.5948C2.87145 1.86559 3.11609 1.66106 3.41108 1.56588C3.61523 1.51238 3.82933 1.50941 4.03489 1.55723C4.30549 1.63589 4.37707 1.69567 5.2644 2.57985C6.04396 3.35627 6.12184 3.44044 6.19657 3.59226C6.33946 3.85875 6.36179 4.17357 6.25793 4.45756C6.17926 4.67389 6.06756 4.81705 5.59479 5.2914L5.28643 5.60055C5.20545 5.68284 5.18642 5.80781 5.23923 5.91048C5.92434 7.07931 6.89634 8.05402 8.06326 8.74238C8.19758 8.8143 8.36299 8.79108 8.47231 8.68495L8.76888 8.39311C8.95217 8.20522 9.14628 8.02819 9.3502 7.86292C9.67049 7.66627 10.0696 7.64872 10.4059 7.81651C10.5703 7.89517 10.6246 7.94394 11.4285 8.74631C12.2576 9.57307 12.2812 9.59903 12.3725 9.78861C12.5442 10.1024 12.5424 10.4825 12.3677 10.7947C12.2789 10.9709 12.2246 11.0346 11.7581 11.5113C11.4765 11.7993 11.2114 12.062 11.1689 12.1005C10.7841 12.4192 10.2904 12.5755 9.79229 12.5363C8.881 12.4533 7.99896 12.1716 7.20818 11.7112C5.45645 10.7831 3.96519 9.43082 2.87066 7.77796C2.63227 7.43205 2.42032 7.06864 2.23663 6.69083C1.74387 5.84627 1.4894 4.88387 1.50034 3.90613C1.53796 3.39462 1.78326 2.9208 2.17921 2.5948Z"
        stroke="#775FD5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
